import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ButtonOptions } from '../eva-button/eva-button.component';
import { EvaMessageOptions } from '../eva-message/eva-message.component';
import { TagTextData } from '../tag-text/tag-text.component';
import { DescriptionDetailedCategory } from './description-detailed-category.component';
import { Module } from 'projects/common/model/ModuleModel';
import { DescriptionDetailedModule } from './description-detailed.component';

export enum DescriptionDetailedViewType {
    ICONS, GROUPS
}

export interface DescriptionDetailedGroup {
    title: TagTextData;
    categories: DescriptionDetailedCategory[];
    eva_messages: EvaMessageOptions[];
    view_type: DescriptionDetailedViewType;
    button: ButtonOptions;
    has_bullet: boolean;
}

@Component({
    selector: 'description-detailed-group',
    template: `
        <tag-text *ngIf="group.title" class="title-group -eva-3-bold" [data]="group.title"></tag-text>
        
        <div *ngIf="group.categories && group.categories.length > 0" class="description-detailed-categories-wrapper">
            <div class="description-detailed-categories view-{{group.view_type}} columns-{{group.categories.length}}">
                <description-detailed-category *ngFor="let category of group.categories" [category]="category" [hasBullet]="group.has_bullet"></description-detailed-category>
            </div>
        </div>

        <ng-container *ngIf="group.eva_messages">
            <eva-message *ngFor="let evaMessage of group.eva_messages" [data]="evaMessage" [uniqueId]="module.unique_id" [moduleIndex]="module.row_number"></eva-message>
        </ng-container>

        <eva-button class="-eva-3-mt-xlg" *ngIf="group.button" [moduleId]="module.id" [moduleIndex]="module.row_number" [uniqueId]="module.unique_id" [options]="group.button"></eva-button>
    `,
    styleUrls: ['./description-detailed.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class DescriptionDetailedGroupComponent {
    @Input() group: DescriptionDetailedGroup;
    @Input() module: Module<DescriptionDetailedModule>;

    constructor() { }
}